import React from 'react'
import {Close} from '@mui/icons-material'
import {twMerge} from 'tailwind-merge'









export const Chip = (props) => {
  const {label, className, picture, icon, onDelete} = props

  return (
    React.createElement('div', {
      className: twMerge(
        'inline-flex h-8 cursor-default items-center justify-start gap-2 rounded bg-slate-100 px-2 py-2',
        className
      ),}

      , icon && icon
      , picture && (
        React.createElement('div', { className: "relative h-6 w-6 rounded border border-slate-100"     ,}
          , React.createElement('div', {
            className: "h-6 w-6 rounded-full bg-cover bg-center bg-no-repeat"     ,
            style: {backgroundImage: `url('${picture}')`},}
          )
        )
      )
      , React.createElement('div', { className: "text-gray-700 text-sm font-semibold leading-normal"   ,}, label)
      , onDelete && (
        React.createElement(Close, {
          className: "text-gray-700 cursor-pointer text-sm hover:opacity-50"   ,
          onClick: onDelete,}
        )
      )
    )
  )
}
